/** PUT a file to a presigned URL with progress; resolves on 2xx. */
export function uploadWithProgress(url: string, file: File, headers: Record<string, string>, onProgress: (pct: number) => void): Promise<void> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("PUT", url, true);
    for (const [k, v] of Object.entries(headers)) xhr.setRequestHeader(k, v);
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable) onProgress(Math.round((e.loaded / e.total) * 100));
    };
    xhr.onload = () => (xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(new Error(`업로드 실패 (HTTP ${xhr.status})`)));
    xhr.onerror = () => reject(new Error("네트워크 오류로 업로드에 실패했습니다"));
    xhr.onabort = () => reject(new Error("업로드가 취소되었습니다"));
    xhr.send(file);
  });
}
